<template>
  <div>
    <el-card class="box-card"
             v-loading="loading">
      <div slot="header" class="clearfix">
        <i class="el-icon-user-solid" style="margin-right: 5px"></i>

        <span>
          Choisir un utilisateur
        </span>
      </div>
      <div v-for="user in users"
           v-bind:key="user.id"
           class="text item">
        <User :user="user"
              data-test='user--test'
              @authTry="authTry($event)"></User>
      </div>
    </el-card>
  </div>
</template>

<script>
  import User from './User/User.vue';

  export default {
    components: {
      User,
    },
    props: {
      users: undefined,
      loading: undefined,
    },
    methods: {
      authTry(auth) {
        this.$emit('authTry', auth);
      },
    },
  };
</script>

<style lang="stylus">
  @media screen and (max-width: 800px)
    .box-card
      width 100%
</style>
